import { isRecord } from "./type-guards";

function getMessage(value: unknown): string | undefined {
  if (!isRecord(value)) return undefined;
  const message = value["message"];
  return typeof message === "string" && message.trim() !== "" ? message : undefined;
}

/**
 * Best-effort read of `react-hook-form` error message at a dotted path.
 *
 * Example paths:
 * - `title`
 * - `sessions.0.startsAt`
 * - `pricePoints.2.label`
 */
export function getRhfErrorMessageAtPath(
  errors: unknown,
  path: string,
): string | undefined {
  if (!path) return getMessage(errors);
  const parts = path.split(".").filter((p) => p.trim() !== "");

  let current: unknown = errors;
  for (const part of parts) {
    if (Array.isArray(current)) {
      const idx = Number(part);
      if (!Number.isInteger(idx) || idx < 0 || idx >= current.length) return undefined;
      current = current[idx];
      continue;
    }

    if (!isRecord(current)) return undefined;
    current = current[part];
  }

  return getMessage(current);
}


